export const slugifyCompanyName = (value) => String(value || 'vendor')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9&-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '') || 'vendor';

export const encodeVendorId = (id) => {
    if (id === null || id === undefined || id === '') return '';

    try {
        return window.btoa(String(id))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/g, '');
    } catch {
        return String(id);
    }
};

export const buildVendorProfileUrl = (vendor, fallbackId = null) => {
    const id = vendor?.id ?? fallbackId;
    if (id === null || id === undefined || id === '') return '';

    const companyName = vendor?.company_name || vendor?.name || 'vendor';
    return `/vendor-details/${slugifyCompanyName(companyName)}/${encodeVendorId(id)}`;
};
